import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { editQuestionnaire } from 'Consts/Questionnaire';
import { lifeInsurancePolicies as enumeratedValuesLifeInsurancePolicies } from 'Consts/EnumeratedValues';
import ShadowBox from 'Components/UI/ShadowBox';
import Currency from 'Components/Format/Currency';
import AccountsHeading from '../Accounts/Heading';
import AccountsTable from '../Accounts/Table';
import AccountsTableInner from '../Accounts/TableInner';
import '../Accounts/index.css';

const LifeInsurance = ({ lifeInsuranceAccounts, isAgent }) => {
  const simpleHousehold = useSimpleHousehold();
  function getEditLink(page, section) {
    return editQuestionnaire(page, {
      section,
      isAgent,
      householdId: simpleHousehold.householdResource.id(),
    });
  }
  return (
    <div className="life-insurance">
      {lifeInsuranceAccounts.length > 0 && (
        <Fragment>
          <AccountsHeading
            title="Life Insurance Cash Value"
            editLink={getEditLink('insurance', 'privateLifeInsurance')}
            editTooltip="Edit Insurance Cash Value"
          >
            <AccountsTable className="accounts-life-insurance-cash-value">
              <tr className="headings">
                <td className="annual">Annual Premium</td>
                <td className="cash-value">Cash Value</td>
                <td className="carrier">Insurance Carrier</td>
                <td className="type">Insurance Type</td>
                <td className="owner">Owner</td>
                <td className="notes">Notes</td>
              </tr>
            </AccountsTable>
          </AccountsHeading>
          {lifeInsuranceAccounts.length > 0 && (
            <Fragment>
              <AccountsTableInner>
                <ShadowBox>
                  <AccountsTable className="accounts-life-insurance-cash-value">
                    {lifeInsuranceAccounts.map(account => (
                      <tr key={`${account.id}lia`} className="data">
                        <td className="annual">
                          {account.attributes.premium !== null && (
                            <Currency amount={account.attributes.premium} />
                          )}
                        </td>
                        <td className="cash-value">
                          {account.attributes.cashValue !== null && (
                            <Currency amount={account.attributes.cashValue} />
                          )}
                        </td>
                        <td className="carrier">{account.attributes.company}</td>
                        <td className="type">
                          {enumeratedValuesLifeInsurancePolicies(
                            'type',
                            account.attributes.type,
                          )}
                        </td>
                        <td className="owner">{account.attributes.insuredClientName}</td>
                        <td className="notes">{account.attributes.notes}</td>
                      </tr>
                    ))}
                  </AccountsTable>
                </ShadowBox>
              </AccountsTableInner>
            </Fragment>
          )}
        </Fragment>
      )}
    </div>
  );
};

LifeInsurance.propTypes = {
  lifeInsuranceAccounts: PropTypes.array.isRequired,
  isAgent: PropTypes.bool.isRequired,
};

export default LifeInsurance;
